import { render } from '@react-email/render';
import React, { useState, useEffect } from 'react';

const RenderReactEmail = ({ component, onRender }) => {
  const [html, setHtml] = useState('');

  useEffect(() => {
    if (!component) return;
    const generateHtml = async () => {
      const renderedHtml = await render(component);
      setHtml(renderedHtml);
      if (onRender) {
        onRender(renderedHtml);
      }
    };
    generateHtml();
  }, [component, onRender]);

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export default RenderReactEmail;
